import React from "react";
import NumberFormat from "react-number-format";

import { TextField } from "@mui/material";
import { FormikProps } from "formik";
import { CurrencyType } from "store/types";

import { currencySign } from "../../../constants";
import { FormValues } from "../schemas";

interface Props {
  formik: FormikProps<FormValues>;
  currency: CurrencyType;
  label?: string;
}

export const LoanAmount: React.FC<Props> = ({ formik, currency, label = "Loan Amount" }) => {
  const symbol = currencySign[currency];

  return (
    <NumberFormat
      fullWidth
      name="loan_amount"
      label={label}
      thousandSeparator
      isNumericString
      placeholder={`${symbol}3,000,000`}
      variant="outlined"
      prefix={symbol}
      error={formik.touched.loan_amount && Boolean(formik.errors.loan_amount)}
      helperText={formik.touched.loan_amount && formik.errors.loan_amount}
      decimalScale={2}
      sx={{
        flexGrow: 1,
        ".MuiInputBase-root": {
          pr: 0,
          overflow: "hidden"
        },
        ".MuiInputBase-input": {
          padding: "9.5px 8px"
        },
        ".MuiButtonBase-root": {
          display: "none"
        },
        "&:hover": {
          ".MuiButtonBase-root": {
            display: "block"
          }
        }
      }}
      allowNegative={false}
      customInput={TextField}
      value={formik.values.loan_amount || null}
      onValueChange={({ value }) => {
        formik.setFieldValue("loan_amount", Number(value));
      }}
    />
  );
};
